// extracted by mini-css-extract-plugin
export var backgroundColor = "#141821";
export var borderRadius = ".15rem";
export var maxModalWidth = "48em";
export var modalBackgroundColor = "rgba(20,24,33,.75)";
export var projectImage = "project-icon-module--project-image--41c85";
export var projectLink = "project-icon-module--project-link--878d9";